import React from 'react';
import { Navbar, Col, NavDropdown, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logout from "../Auth/Logout";
import { useNavUI } from '../Context/NavUIContext';
import apiUrl from '../Helpers/APIWrapper';

export default function DesktopNav({ isAuthenticated, setIsAuthenticated, l, setLanguage }: any) {
  const { state, dispatch } = useNavUI();
  const { adminOpen, languageOpen, aboutOpen, referenceOpen, productOpen, expertiseOpen } = state;

  // helpers
  const setOpen = (key: "adminOpen" | "languageOpen" | "aboutOpen" | "referenceOpen" | "productOpen" | "expertiseOpen", value: boolean) =>
    dispatch({ type: "set", key, value });

  // Extract the first part of the pathname (e.g., "products" from "/products/ProductName")
  const pathParts = window.location.pathname.split("/").filter(part => part);
  const location = pathParts[0] || "";
  const disabledLocations = ["editpage", "admin"];
  
  // Map detailed pages to their edit page equivalents
  const getEditPageType = (loc: string) => {
    if (loc === "products") return "products";
    if (loc === "references") return "references";
    return loc;
  };
  
  const editPageType = getEditPageType(location);
  
  // Extract section for expertise pages (e.g., "rust-protection" from "/expertise/rust-protection")
  const getSection = () => {
    if (location === "expertise" && pathParts.length > 1) {
      return pathParts[1];
    }
    return null;
  };
  
  const section = getSection();

  return (
    <>
      <Navbar className='align-items-center pb-3 navbar-custom'>
        <Row className='w-100 m-0 p-0 align-items-center'>
          <Col xxl={5} xl={4} lg={4} md={5}>
            <Navbar.Brand href="/">
              <img src='/images/introteknik_logo_text.png' className="navbar-logo" />
            </Navbar.Brand>
          </Col>

          <Col xxl={2} lg={3} md={2} className='text-center me-2 ms-auto' style={{ cursor: "pointer" }}>
            <Row>
              <Col className='text-end'>
                {isAuthenticated && (
                  <NavDropdown
                    id="admin-dropdown"
                    className="info-dropdown"
                    renderMenuOnMount
                    show={adminOpen}
                    onMouseEnter={() => setOpen("adminOpen", true)}
                    onMouseLeave={() => setOpen("adminOpen", false)}
                    onToggle={(next) => setOpen("adminOpen", !!next)}
                    title={<i className="fa fa-cog" style={{ fontSize: "45px" }}></i>}
                  >
                    <NavDropdown.Item href="/references">Admin</NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/editpage"
                      state={{ location: editPageType, section: section }}
                      disabled={disabledLocations.includes(location)}
                    >
                      {l('Redigera sida', 'Edit page')}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => logout(setIsAuthenticated)}>
                      {l('Logga ut', 'Log out')}
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
              </Col>

              <Col className='text-end'>
                <NavDropdown
                  id="language-dropdown"
                  className="info-dropdown"
                  renderMenuOnMount
                  show={languageOpen}
                  onMouseEnter={() => setOpen("languageOpen", true)}
                  onMouseLeave={() => setOpen("languageOpen", false)}
                  onToggle={(next) => setOpen("languageOpen", !!next)}
                  title={<i className="fa fa-globe" style={{ fontSize: "45px" }}></i>}
                >
                  <NavDropdown.Item onClick={() => setLanguage("eng")}>English</NavDropdown.Item>
                  <NavDropdown.Item onClick={() => setLanguage("swe")}>Svenska</NavDropdown.Item>
                </NavDropdown>
              </Col>
            </Row>
          </Col>
        </Row>
      </Navbar>

      <Container
        className="d-flex justify-content-center"
        style={{ backgroundColor: "var(--newGray)", borderRadius: "10px" }}
      >
        <Row className="text-center py-3">
          <Col>
            <Navbar.Brand href="/" className="navbar-link menuLink p-2">
              {l('Hem', 'Home')}
            </Navbar.Brand>
          </Col>
          <Col>
            <NavDropdown
              id="about-dropdown"
              className="about-dropdown"
              renderMenuOnMount
              show={aboutOpen}
              onMouseEnter={() => setOpen("aboutOpen", true)}
              onMouseLeave={() => setOpen("aboutOpen", false)}
              onToggle={(next) => setOpen("aboutOpen", !!next)}
              title={<Navbar.Brand className="navbar-link menuLink p-2">{l('Om Introteknik', 'About Introteknik')}</Navbar.Brand>}>
              <NavDropdown.Item href="/about">{l('Vision & idé', 'Vision & idea')}</NavDropdown.Item>
              <NavDropdown.Item href="/contact">{l('Konktakt', 'Contact')}</NavDropdown.Item>
            </NavDropdown>
          </Col>

          <Col>
            <NavDropdown
              id="about-dropdown"
              className="about-dropdown"
              renderMenuOnMount
              show={expertiseOpen}
              onMouseEnter={() => setOpen("expertiseOpen", true)}
              onMouseLeave={() => setOpen("expertiseOpen", false)}
              onToggle={(next) => setOpen("expertiseOpen", !!next)}
              title={<Navbar.Brand className="navbar-link menuLink p-2">{l('Verksamhetsområden', 'Markets')}</Navbar.Brand>}>
              <NavDropdown.Item href="/expertise/rust-protection">{l('Rostskydd', 'Rust protection')}</NavDropdown.Item>
              <NavDropdown.Item href="/expertise/roof-painting">{l('Takmålning', 'Roof painting')}</NavDropdown.Item>
              <NavDropdown.Item href="/expertise/cultural-heritage">{l('Kulturhistoriska objekt', 'Cultural heritage objects')}</NavDropdown.Item>
            </NavDropdown>
          </Col>

          <Col>
            <NavDropdown
              id="about-dropdown"
              className="about-dropdown"
              renderMenuOnMount
              show={referenceOpen}
              onMouseEnter={() => setOpen("referenceOpen", true)}
              onMouseLeave={() => setOpen("referenceOpen", false)}
              onToggle={(next) => setOpen("referenceOpen", !!next)}
              title={<Navbar.Brand className="navbar-link menuLink p-2">{l('Referenser', 'References')}</Navbar.Brand>}>
              <NavDropdown.Item href="/references">{l('Kundutlåtanden', 'Customer statements')}</NavDropdown.Item>
              <NavDropdown.Item href="/reports">{l('Rapporter', 'Reports')}</NavDropdown.Item>
              <NavDropdown.Item href="/tests">{l('Tester', 'Tests')}</NavDropdown.Item>
            </NavDropdown>
          </Col>

          <Col>
            <NavDropdown
              id="about-dropdown"
              className="about-dropdown"
              renderMenuOnMount
              show={productOpen}
              onMouseEnter={() => setOpen("productOpen", true)}
              onMouseLeave={() => setOpen("productOpen", false)}
              onToggle={(next) => setOpen("productOpen", !!next)}
              title={<Navbar.Brand className="navbar-link menuLink p-2">{l('Produkter', 'Products')}</Navbar.Brand>}>
              <NavDropdown.Item href="/products">{l('Produktlista', 'Product list')}</NavDropdown.Item>
              <NavDropdown.Item href="/sheets">{l('Data/Säkerhetsblad', 'Data and safety sheets')}</NavDropdown.Item>
            </NavDropdown>
          </Col>

          <Col>
            <Navbar.Brand href="/retail" className="navbar-link menuLink p-2">
              {l('Återförsäljare', 'Retailers')}
            </Navbar.Brand>
          </Col>
          {/*           <Col>
            <Navbar.Brand href="/" className="navbar-link menuLink p-2">
              {l('Säkerhetsblad', 'Safety sheets')}
            </Navbar.Brand>
          </Col> */}
        </Row>
      </Container>

    </>
  );
};